<template>
    <div
        id="navbar-content"
        class="navbar__content"
        :class="{'navbar__content--open': isOpen, 'navbar__content--multiple-modes': hasMultipleModes}"
        data-testid="navbar-content"
    >
        <NavbarMenu
            v-if="hasMenuItems"
            :nav="nav"
            :open-menu-index="openMenuIndex"
            @toggle-menu="$emit('toggle-menu', $event)"
            @close-menu="$emit('close-menu')"
        />
        <NavbarActions />
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import type {NavbarConfig} from '@navbar-unlogged-types';
    import NavbarActions from './NavbarActions.vue';
    import NavbarMenu from './NavbarMenu.vue';
    import {useNavbarMode} from '../composables/useNavbarMode';

    const props = defineProps<{
        isOpen: boolean;
        nav: NavbarConfig;
        openMenuIndex: number | null;
    }>();

    defineEmits<{
        'toggle-menu': [index: number];
        'close-menu': [];
    }>();

    const {hasMultipleModes} = useNavbarMode();
    const hasMenuItems = computed(() => props.nav && props.nav.items && props.nav.items.length > 0);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    /* mobile-first */
    .navbar__content {
        display: flex;
        flex-direction: column;
        background-color: var(--joy-color-neutral-0);
        position: fixed;
        left: 0;
        width: 100vw;
        height: calc(100vh - var(--navbar-height));
        height: calc(100dvh - var(--navbar-height));
        top: 100%;
        overflow: hidden;
        z-index: 1;
        opacity: 0;
        visibility: hidden;
        transform: translateY(-20px);
        transition:
            opacity var(--navbar-transition-duration) var(--navbar-transition-easing),
            visibility var(--navbar-transition-duration) var(--navbar-transition-easing),
            transform var(--navbar-transition-duration) var(--navbar-transition-easing);

        &--open {
            opacity: 1;
            visibility: visible;
            transform: translateY(0);
        }

        &--multiple-modes {
            padding-top: var(--navbar-height);
        }
    }

    /* desktop */
    @include mq.screen_md(min) {
        .navbar__content {
            flex-direction: row;
            justify-content: space-between;
            flex: 1;
            height: 100%;
            position: static;
            width: auto;
            opacity: 1;
            visibility: visible;
            overflow: visible;
            transform: none;
            transition: none;
            padding-top: 0;
        }
    }
</style>
